import { Injectable } from '@angular/core';
import {
  ClinicPlatformBillingInvoice, ClinicPlatformBillingState, ClinicPlatformBillingStatus,
  PayInvoiceOutcome, PayInvoiceResult,
} from '../../domain/models/platform-billing-status.model';
import {
  ClinicPlatformBillingInvoiceDto, ClinicPlatformBillingStatusDto, PayInvoiceResultDto,
} from '../dtos/platform-billing.dto';

@Injectable()
export class PlatformBillingMapper {
  public toStatus(dto: ClinicPlatformBillingStatusDto): ClinicPlatformBillingStatus {
    return {
      State: dto.State as ClinicPlatformBillingState,
      IsBillingSuspended: dto.IsBillingSuspended,
      OutstandingAmount: dto.OutstandingAmount,
      Currency: dto.Currency,
      EarliestDueAtUtc: dto.EarliestDueAtUtc,
      GraceEndsAtUtc: dto.GraceEndsAtUtc,
      Invoices: dto.Invoices.map((invoice) => this.toInvoice(invoice)),
      CurrentPeriodStartUtc: dto.CurrentPeriodStartUtc ?? null,
      CurrentPeriodEndUtc: dto.CurrentPeriodEndUtc ?? null,
    };
  }

  public toInvoices(dtos: readonly ClinicPlatformBillingInvoiceDto[]): readonly ClinicPlatformBillingInvoice[] {
    return dtos.map((dto) => this.toInvoice(dto));
  }

  public toInvoice(dto: ClinicPlatformBillingInvoiceDto): ClinicPlatformBillingInvoice {
    return {
      ...dto,
      PaidAtUtc: dto.PaidAtUtc ?? null,
      PeriodStartUtc: dto.PeriodStartUtc ?? null,
      PeriodEndUtc: dto.PeriodEndUtc ?? null,
      // Defaults to false on purpose: an older or partial payload hides the pay action rather than
      // offering one the server would refuse.
      IsGatewayManaged: dto.IsGatewayManaged ?? false,
    };
  }

  public toPayInvoiceResult(dto: PayInvoiceResultDto): PayInvoiceResult {
    return {
      Outcome: dto.Outcome as PayInvoiceOutcome,
      ClientSecret: dto.ClientSecret,
      PublishableKey: dto.PublishableKey,
      ErrorMessage: dto.ErrorMessage,
      ErrorCode: dto.ErrorCode ?? null,
    };
  }
}
